import { Button } from "@msuite/ui/button";
import { useLoading } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { queries } from "@msuite/zero";
import { useZeroQuery } from "@msuite/zero/react";
import { useCrewHandler } from "@/sites/plan/plan-kanban/use-crew-handler";
import { useDailyContext } from "../daily/context";
import { useCrewContext } from "./context";

/** Props Interface */
interface TicketAssignmentActionButtonProps {
	assignmentId: string;
}

export function TicketAssignmentActionButton({ assignmentId }: TicketAssignmentActionButtonProps) {
	/** Context */
	const { canArrangeTicketOf } = useDailyContext();

	/** Hooks */
	const { planId, crewId } = useCrewContext();
	const [assignment] = useZeroQuery(queries.ticketAssignments.byId({ id: assignmentId }));
	const crewHandler = useCrewHandler({ planId, crewId });
	const loader = useLoading();

	if (!assignment || loader.isLoading) return null;
	// Taking work off a column is arranging that project's work, so the control is absent on a
	// published day and for a caller outside the fixed ticket rule.
	if (!canArrangeTicketOf(assignment.projectId)) return null;

	/** Functions */
	async function handleOnDeleteAssignment() {
		if (!assignment) return;
		loader.start();
		crewHandler.onDeleteTicketAssignment(assignmentId);
	}

	/** Render */
	return (
		<div className="-mx-1.5 -my-2">
			<Button
				variant="ghost"
				icon={<Icon name="Undo" />}
				onClick={handleOnDeleteAssignment}
				isLoading={loader.isLoading}
			/>
		</div>
	);
}
